import { HttpClient, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { map, Observable, of, Subject } from 'rxjs'
import { catchError } from 'rxjs/operators'

import { NUMBER_TWO_HUNDRED } from '../../../constants/constant.numbers'
import { ConstantUrls } from '../../../constants/constant.urls'
import { initializeIUserLogonObject, IUserLogon } from '../../models/user-logon'
import { EnvironmentService } from '../environment/environment.service'

@Injectable({
  providedIn: 'root',
})
export class UserLogonService {
  userLogonData: IUserLogon = initializeIUserLogonObject()
  userLogonDataSubject = new Subject<IUserLogon>()

  constructor(
    private http: HttpClient,
    private readonly environmentService: EnvironmentService,
  ) {}

  isUserLoggedOnMonolith(
    isLoggedOnMonolithURL: string,
  ): Observable<IUserLogon> {
    return this.http.get<IUserLogon>(isLoggedOnMonolithURL).pipe(
      map((response: IUserLogon) => {
        this.userLogonData = response
        return this.userLogonData
      }),
      catchError((error) => {
        this.userLogonData.isLoggedOn = false
        console.error('Error occurred while fetching user logon data:', error)
        return of(this.userLogonData)
      }),
    )
  }

  getUserLogonData(): Observable<IUserLogon> {
    return this.userLogonDataSubject.asObservable()
  }

  isUserLoggedOnB2B(isLoggedOnB2BURL: string) {
    return this.http.get(isLoggedOnB2BURL, { observe: 'response' }).pipe(
      map((response: HttpResponse<any>) => {
        if (response.status === NUMBER_TWO_HUNDRED) {
          this.userLogonData.isLoggedOn = true
        } else {
          this.userLogonData.isLoggedOn = false
        }
        return this.userLogonData
      }),
      catchError((error) => {
        this.userLogonData.isLoggedOn = false
        this.userLogonDataSubject.next(this.userLogonData)
        console.error(
          'Error occurred while fetching user b2b logon data:',
          error,
        )
        return of(this.userLogonData)
      }),
    )
  }

  isUserLoggedOn(configURL: any): void {
    let isB2BLogOn = false
    this.http
      .get<any>(
        configURL[this.environmentService.envType].external.BASE_HOST +
          ConstantUrls.TOGGLE_B2B_STATUS,
      )
      .subscribe({
        next: (result) => {
          isB2BLogOn = result?.data?.b2blogontoggleList?.items[0].b2bLogonToggle
          let logonURL: string
          let response: Observable<IUserLogon>
          if (isB2BLogOn) {
            logonURL =
              configURL[this.environmentService.envType].external.BASE_HOST +
              ConstantUrls.IS_LOGON_B2B
            response = this.isUserLoggedOnB2B(logonURL)
          } else {
            logonURL =
              configURL[this.environmentService.envType].external.BASE_HOST +
              ConstantUrls.IS_LOGGED_ON
            response = this.isUserLoggedOnMonolith(logonURL)
          }
          response.subscribe({
            next: () => {
              this.userLogonDataSubject.next(this.userLogonData)
            },
            error: () => {
              this.userLogonDataSubject.next(this.userLogonData)
            },
          })
        },
        error: (e) => {
          console.error('error at b2b logon', e)
        },
      })
  }
}
